module.exports = __webpack_public_path__ + "static/media/ael.e63f0981.png";